import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription, pairwise } from 'rxjs';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { PlannedMaintenanceAction } from '../../model/object-component-planned-maintenance';

@Component({
    selector: 'app-planned-maintenance-action',
    templateUrl: './planned-maintenance-action.component.html',
    styleUrls: ['./planned-maintenance-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlannedMaintenanceActionComponent implements OnInit, OnDestroy {
  constructor(
    private _cf: FormControlExFactory,
    private _fb: FormBuilder
  ) {}

  private _forms: FormArray;
  @Input() set forms(value: AbstractControl) {
    this._forms = value as FormArray;
  }
  get forms(): FormArray {
    return this._forms;
  }
  @Input() rootForm: FormGroup;
  @Input() plannedMaintenanceAction: PlannedMaintenanceAction;
  private _subscription = new Subscription();
  form: FormGroup;

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.createActionValueForm(this.plannedMaintenanceAction);
    this.forms.controls.push(this.form);
  }

  private createActionValueForm(plannedMaintenanceAction: PlannedMaintenanceAction): FormGroup {
    let group = this._fb.group({
      id: this._cf.createHidden(plannedMaintenanceAction.id),
      plannedMaintenanceCaption: this._cf.create(
        'COMPONENT.PLANNED_MAINTENANCE_ACTION.CAPTION',
        plannedMaintenanceAction.plannedMaintenanceCaption
      ),
      latestMaintenanceExecution: this._fb.group({}),
      plannedMaintenanceInterval: this._cf.create(
        'COMPONENT.PLANNED_MAINTENANCE_ACTION.INTERVAL',
        plannedMaintenanceAction.plannedMaintenanceInterval
      ),
    });
    this._subscription.add(group.valueChanges.pipe(pairwise()).subscribe(x => this.rootForm.markAsDirty()));
    return group;
  }
}
